/* Product gallery CTA overlay: add-to-cart button on last slide.
   - Shows spinner while adding.
   - Hides button and shows SOLD OUT when variant is not purchasable.
   - Triggers the existing product-form submit for full compatibility. */
(function () {
  function qs(selector, root = document) { return root.querySelector(selector); }

  function init() {
    var gallery = qs('[data-pslider]');
    if (!gallery) return;
    var ctaSlide = qs('[data-cta-slide]', gallery);
    if (!ctaSlide) return; // nothing to do

    var cartBtn = qs('[data-cta-button]', ctaSlide);
    var spinner = qs('.pslider__cta-spinner', ctaSlide);
    var soldOut = qs('[data-cta-soldout]', ctaSlide);
    var productInfo = document.querySelector('product-info');
    var submitBtn = productInfo?.querySelector('.product-form__submit') || document.querySelector('.product-form__submit');

    function isPurchasable() {
      return !!submitBtn && !submitBtn.hasAttribute('disabled');
    }

    function refresh() {
      var ok = isPurchasable();
      if (cartBtn) cartBtn.style.display = ok ? '' : 'none';
      if (soldOut) soldOut.hidden = ok;
    }

    refresh();

    // Listen to variant changes to keep state in sync
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, refresh);
        subscribe(PUB_SUB_EVENTS.cartUpdate, function(){ spinner?.classList.add('hidden'); cartBtn?.removeAttribute('disabled'); });
        subscribe(PUB_SUB_EVENTS.cartError, function(){ spinner?.classList.add('hidden'); cartBtn?.removeAttribute('disabled'); refresh(); });
      }
    } catch (e) { /* no-op */ }

    // Fallback: update on change of hidden id input
    document.addEventListener('change', function (e) {
      if (e.target?.name === 'id') refresh();
    });

    cartBtn?.addEventListener('click', function (e) {
      e.preventDefault();
      if (!isPurchasable()) return;
      spinner?.classList.remove('hidden');
      cartBtn.setAttribute('disabled', 'true');
      // Trigger the main submit button to reuse the theme's product-form logic
      submitBtn?.click();
    });
  }

  function boot() {
    init();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

